import React from 'react';
import PropTypes from 'prop-types';

import UltimatePagination from 'react-ultimate-pagination-bootstrap-4';
import queryString from 'query-string';
import { Card } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck, faSearch } from '@fortawesome/pro-solid-svg-icons';

import { connect } from 'react-redux';
import { changePage } from './store/actions/query';
import { retrieveRecords, filterOptionsAsQueryParameter } from './store/actions/search';

import CsvDownloadButton from  'components/csv_download_button';
import LoadingSpinner from 'components/ui/loading_spinner';
import PageHeader from 'components/page_header';
import EmptyState from 'shared/empty_state';
import WebhookEventsTable from './webhook_events_table';
import WebhookEventFilterTopbar from './webhook_event_filter_topbar';

export class WebhookEvents extends React.Component {
  static propTypes = {
    currentPage: PropTypes.number.isRequired,
    isFetchingWebhookEvents: PropTypes.bool.isRequired,
    isFiltered: PropTypes.bool.isRequired,
    paths: PropTypes.shape({
      webhookEventsCsvPath: PropTypes.string
    }).isRequired,
    retrieveRecords: PropTypes.func.isRequired,
    totalCount: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    webhookEvents: PropTypes.array.isRequired,
    onPageChange: PropTypes.func.isRequired
  }

  componentDidMount() {
    this.props.retrieveRecords();
  }

  handlePageChange = (page) => {
    this.props.onPageChange(page);
    this.props.retrieveRecords();
  };

  csvDownloadPath() {
    const filters = filterOptionsAsQueryParameter(this.props.query);
    const paramsQueryString = queryString.stringify(filters, { arrayFormat: 'bracket' });
    return `${this.props.paths.webhookEventsCsvPath}?${paramsQueryString}`;
  }

  render() {
    return <>
      {this.renderPageHeader()}

      <div className="container d-flex flex-column gap-4 my-4">
        <Card>
          <Card.Body>
            <WebhookEventFilterTopbar />
          </Card.Body>
        </Card>

        {this.renderResults()}
        {this.renderPagination()}
      </div>
    </>;
  }

  renderPageHeader() {
    return (
      <PageHeader
        iconDescription="View existing webhook events"
        iconName={faCalendarCheck}
        iconSize="lg"
        iconText="Webhook Events"
        iconType="icon"
      >
        <CsvDownloadButton href={this.csvDownloadPath()} type="Button" />
      </PageHeader>
    );
  }

  renderResults() {
    if (this.props.isFetchingWebhookEvents) {
      return <LoadingSpinner />;
    } else if (this.props.webhookEvents.length > 0) {
      return <WebhookEventsTable />;
    } else if (this.props.totalCount === 0) {
      return (
        <EmptyState
          header="No results found"
          icon={faSearch}
        >
          Search with different criteria
        </EmptyState>
      );
    }
  }

  renderPagination() {
    if (!this.props.isFetchingWebhookEvents) {
      if (this.props.webhookEvents.length >= this.props.totalCount) {
        return <div className="my-5" />;
      }

      return (
        <div className="d-flex justify-content-center">
          <UltimatePagination
            currentPage={this.props.currentPage}
            totalPages={this.props.totalPages}
            onChange={this.handlePageChange}
          />
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  const isFiltered = !(
    state.query.searchText === '' &&
    state.query.eventTypeFilter.length === 0 &&
    state.query.identifier === '' &&
    state.query.maxDate === null &&
    state.query.minDate === null &&
    state.query.statusFilter.length === 0
  );

  return {
    ...state.search.meta,

    webhookEvents: state.search.webhookEvents,
    isFetchingWebhookEvents: state.search.isFetching,
    isFiltered,
    paths: state.paths,
    query: state.query
  };
};

const mapDispatchToProps = {
  onPageChange: changePage,
  retrieveRecords
};

export default connect(mapStateToProps, mapDispatchToProps)(WebhookEvents);
